import { Permissions } from "./permissions";

export enum Role {
  GENERAL = "general",
  CORE = "core",
  ADMIN = "admin",
}

export const RoleToPermissions: Record<Role, Permissions[]> = {
  [Role.GENERAL]: [Permissions.QUERY_RATES],
  [Role.CORE]: [Permissions.QUERY_RATES, Permissions.UPLOAD_DOCUMENT],
  [Role.ADMIN]: Object.values(Permissions) as Permissions[],
};
